import { generateRatingArray } from "./rating.js";
export const calculateStars = ({ star , halfStar , value  })=>{
    // Call the generateRatingArray function with the provided star and halfStar symbols, and the rating value.
    // Set the maximum number of symbols equal to the rounded rating value to avoid the default maximum=5
    const starts = generateRatingArray({
        symbol: {
            full: star,
            half: halfStar,
            empty: ''
        },
        rating: value,
        maximum: Math.round(value)
    });
    return starts;
};
export default calculateStars;

//# sourceMappingURL=calculate-stars.js.map